import React, { useState, KeyboardEvent } from "react";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faXmark } from "@fortawesome/free-solid-svg-icons";

type propsType = {
  height?: string;
  className?: string;
  style?: object;
  initialValue?: string;
  placeholder?: string;
  onSearch?: (query: string) => void;
  icon?: JSX.Element;
  disabled?: boolean;
  searchOnClear?: boolean;
};

function SearchBox({
  height,
  className,
  style,
  initialValue,
  placeholder = "Search...",
  onSearch,
  icon,
  disabled = false,
  searchOnClear = false,
  ...props
}: propsType) {
  const [searchQuery, setSearchQuery] = useState<string>(
    initialValue === undefined ? "" : initialValue!
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handleSearch = (value: string = searchQuery) => {
    if (onSearch) onSearch(value);
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleClear = () => {
    setSearchQuery("");
    if (searchOnClear) handleSearch("");
  };

  return (
    <div
      style={{
        ...style,
        ...(height !== undefined && height !== null
          ? {
              height: height,
            }
          : {}),
      }}
      {...props}
      className={
        "search-box" +
        (className === undefined || className === null ? "" : " " + className)
      }
    >
      <div
        className={
          "surface input-container" +
          (searchQuery.length === 0 ? "" : " has-text")
        }
      >
        <input
          type="text"
          value={searchQuery}
          onChange={handleChange}
          onKeyDown={handleKeyPress}
          title="search"
          placeholder={placeholder}
          disabled={disabled}
        />
        <button
          onClick={handleClear}
          className="clear-button button primary text"
          style={searchQuery.length === 0 ? { display: "none" } : {}}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faXmark} size="xl" />
        </button>
      </div>
      <button
        onClick={() => handleSearch()}
        className={"search-button button primary" + (disabled ? "" : " text")}
        disabled={disabled}
      >
        {icon ?? <FontAwesomeIcon icon={faSearch} size="xl" />}
      </button>
    </div>
  );
}

export default SearchBox;
